import { CalendarRange, Id } from "PFTypes";

import { PER_PAGE, RequestData } from "./get_request_data";

export const getRoleProfilesRequest = (
  id: Id,
  dateRange: CalendarRange,
  perPage: number = PER_PAGE
): RequestData => ({
  url: "booking_module/activity_profiles",
  params: { perPage, activityId: id, dateRange },
  childrenType: "profile"
});
